<template>
  <div id="VehicleList">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">{{ pageTitle }}</div>
          <div class="web-action-btn">
            <div class="btn-groups text-right">
              <clear-cache-data :pageKey="[pageKey]"></clear-cache-data>
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                <i class="fp-export"></i> Export
              </a>
            </div>
          </div>
          <div class="mobile-action-btn elipse-btn">
            <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left"
                    aria-expanded="false" v-on:click.prevent="myFunction">
              <i class="fp-ellipsis-v"></i>
            </button>
            <div id="myDropdown" class="dropdown-content">
              <ul>
                <li><a href="javascript:void(0)" class="" v-on:click="exportCheck()">Export</a></li>

              </ul>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content asset-lists">
            <data-table-filter-config :moduleName="'availableVehicleList'" ref="filterComponent"
                                      @cancelSelection="cancelAll"
                                      :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in
                process. batch no. is {{ batchNum }}.
                <router-link class="color-blue"
                             v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0">
                  Click Here
                </router-link>
                to check file status!
              </p>
              <section class="bg-white data-table">
                <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange"
                                   :moduleName="'availableVehicleList'" :position="'top'">
                </custom-pagination>

                <vue-good-table ref="listAvailableVehicleTable" mode="remote" @on-page-change="onPageChange"
                                @on-selected-rows-change="selectionChanged" @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange" @on-sort-change="onSortChange"
                                :totalRows="totalRecords" :columns="userColumns" :rows="rows"
                                @on-select-all="onSelectAll" :pagination-options="{
                                              enabled: false,
                                              position: 'both',
                                              setCurrentPage:listCurrentPage,
                                              perPage: perPage,
                                              perPageDropdown:dropDownPerPage,
                                              dropdownAllowAll: false,
                                          }" :select-options="{
                                              enabled: false,
                                              selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                              selectionInfoClass: 'custom-class',
                                              selectionText: 'rows selected',
                                              clearSelectionText: 'clear',
                                          }" :search-options="{
                                              enabled: false,
                                          }" :sort-options="{
                                              enabled: true,
                                          }">

                  <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                    <div :key="key">
                      <div v-if="props.column.field === 'option_code'">
                        <span
                          class="popover-dismiss"
                          role="button"
                          tabindex="0"
                          data-container="body"
                          data-toggle="popover"
                          data-trigger="focus"
                          data-placement="right"
                          :data-content="
                          props.row.option_description ?
                          `${props.row.option_code} - ${props.row.option_description}`
                          : props.row.option_code"
                          style="cursor: pointer"
                        >
                          {{ props.row.option_code }}
                        </span>
                      </div>
                      <div v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </div>
                    </div>
                  </template>
                  <!-- todo need to verify if the place order functionality is need or not, also the sell vehicle will have to be changed!-->
                  <div slot="selected-row-actions">
                    <button v-if="pageType === 'available-vehicles' && !customOrderMode"
                            id="placeOrderBtn" v-on:click.prevent="PlaceOrder"
                            class="btn btn-primary">Place Order
                    </button>
                    <button v-if="pageType === 'asset-list' && canSellVehicle" id="sellVehicleBtn"
                            v-on:click.prevent="sellVehicle" class="btn btn-primary">Sell
                      Vehicle
                    </button>
                  </div>
                </vue-good-table>
                <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>

          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="col-md-12">
          <div class="error-template">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

import EventBus from "./event-bus";
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

export default {
  name: "AvailableVehiclesList",
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "",
  },
  components: {},
  mixins: [commonMixins, contractMixins, dataTableMixins],
  data: () => ({
    pageTitle: "",
    firstLoad: 0,
    permissions: [],
    cantAccessPage: "",
    userColumns: [],
    velocity_env: process.env.NODE_ENV,
    pageType: "asset-list",
    columns: [
      {
        label: 'Vehicles Available',
        field: 'available_vehicles',
        filterable: true,
        fpFieldType: "integer",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Available Vehicles", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Year',
        field: 'year',
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Year", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Model #',
        field: 'model_code',
        filterable: true,
        fpFieldType: "option",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Model", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter", //only trigger on enter not on keyup
          filterDropdownItems:[
            'e16L',
            'e16M',
            'e18L',
            'e18M',
          ],
        }
      },
      {
        label: 'Wheelbase',
        field: 'wheelbase',
        fpFieldType: "option",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Wheelbase", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter", //only trigger on enter not on keyup
          filterDropdownItems: [
            '134',
            '152',
            '175',
            '187'
          ]
        }
      },
      {
        label: 'Option Code',
        field: 'option_code',
        filterable: true,
        fpFieldType: "option",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Option Code", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter", //only trigger on enter not on keyup
          filterDropdownItems: [],
        }
      },
      {
        label: 'Color',
        field: 'color',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Asset color", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Purchase Price',
        field: 'price',
        filterable: true,
        fpFieldType: "integer",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Purchase Price", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
    ],
    rows: [],
    totalRecords: 0,
    loading: false,
    action: "list",
    pageKey: "_vehicle_list_",
    batchProcess: 0,
    batchNum: "",
    flag: "active",
    customOrderMode: false,
    canSellVehicle: false,
    canAssignVehicle: false,
  }),
  watch: {
    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (self.velocity_env === 'velev' || self.velocity_env === 'velev_test') {
            if (permissions[i].name === 'ev_list_vehicle') {
              self.cantAccessPage = true;
            }
            if (permissions[i].name === "ev_change_vehicle_status_to_sold") {
              self.canSellVehicle = true;
            }
          } else {
            if (permissions[i].name === 'list_asset') {
              self.cantAccessPage = true;
            }
          }
          if (permissions[i].name === 'ev_assign_vehicle_to_order') {
            self.canAssignVehicle = true;
          }
        }
      }
    },
    canAssignVehicle(value) {
      if(value){
        this.columns.splice(1,0,{
          label: 'Vehicles Pending Sale',
          field: 'vehicles_pending_for_sale',
          filterable: false,
          fpFieldType: "integer",
          hidden: false,
          sortable: false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Available Vehicles", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        });
      }
    },
  },
  mounted: function () {
    var self = this;

    self.pageType = "available-vehicles";
    self.pageTitle = "Available Vehicle List";
    self.$options.metaInfo.title = `Available Vehicle List | ${process.env.COPYRIGHT_NAME}`;

    //self.loadList();
    self.getPermissions();

    self.$nextTick(() => {
      self.initializePopovers();
    });
  },
  updated: function() {
    var self = this;
    self.initializePopovers();
  },

  methods: {
    initializePopovers() {
      this.$nextTick(() => {
        // destroy any existing popovers first (optional, but avoids duplicates)
        $('.popover-dismiss').popover('dispose');
        // re-initialize with focus trigger
        $('.popover-dismiss').popover({
          trigger: 'focus'
        });
      });
    },

    cancelAll: function (cancelAll) {
      this.$refs.listAvailableVehicleTable.unselectAllInternal();
    },

    selectionChanged(param) {
      var self = this;
      self.serverParams.selectedAll = false;
      if (param.selectedRows.length === 100) {
        EventBus.$emit('clear-selection', false);
      } else {
        EventBus.$emit('clear-all-flags', false);
      }
    },

    exportCheck: function () {
      var actionFlag = "";
      var data = this.$refs['listAvailableVehicleTable'].selectedRows;
      var count = data.length;
      if (this.serverParams.selectedAll === true) {
        actionFlag = "";
      } else if (count !== 0 && count <= 100) {
        actionFlag = "export";
      }
      this.exportReports(actionFlag);
    },

    loadList() {

      var self = this;
      self.loading = true;

      //self.serverParams.columnFilters = params;

      var selectedRows = [];

      //because on first load list not initialize
      var data = this.$refs['listAvailableVehicleTable'].selectedRows;
      for (var i = 0; i < data.length; i++) {
        selectedRows.push(this.$refs['listAvailableVehicleTable'].selectedRows[i].id)
      }

      var fields = {
        page: self.serverParams.page,
        perPage: self.serverParams.perPage,
        filters: self.serverParams.columnFilters,
        sort: self.serverParams.sort,
        selectedRows: selectedRows,
        action: self.action,
        selectedAll: self.serverParams.selectedAll,
        flag: self.flag,
        listData: self.pageType
      };

      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/asset/list",
        type: "POST",
        data: fields,
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status === "success") {

            if (self.action === "export" || self.action === "export_queue") {
              if (data.code === "201") {
                alert(data.message);
              } else {
                if (self.action === "export") {
                  self.excel = data.content;
                  var save = document.createElement("a");
                  save.href = self.excel;
                  save.download = data.content;
                  save.target = "_blank";

                  document.body.appendChild(save);
                  save.click();
                  document.body.removeChild(save);

                } else {

                  self.batchProcess = 1;
                  self.batchNum = data.content;
                }
              }
              self.action = "list";
            } else {
              self.rows = data.content.row;
              self.totalRecords = data.content.totalRecords;
              self.filteredFlag = false;
            }
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;

          if (self.action === "delete") {
            self.generateStatusCodeMessage(jqXHR, true, 'delete-asset-list')
          } else if (self.action === "export") {
            self.generateStatusCodeMessage(jqXHR, true, 'export-asset-list')
          } else if (self.action === "recall") {
            self.generateStatusCodeMessage(jqXHR, true, 'recall-asset-list')
          } else {
            self.generateStatusCodeMessage(jqXHR, false, 'get-asset-list')
          }

        }
      });
    },

    PlaceOrder() {
      var self = this;
      var selectedData = this.$refs['listAvailableVehicleTable'].selectedRows;
      if (selectedData.length > 1) {

        self.$swal({
          title: "",
          text: "Order Cannot be placed for multiple vehicles at the same time!",
          type: "error",
          confirmButtonText: "Ok",
          showCloseButton: true,
          showLoaderOnConfirm: true
        }).then(result => {
          return;
        });
      } else if (selectedData[0].is_ordered === 1) {
        self.$swal({
          title: "",
          text: "Order has already been placed for this vehicle.",
          type: "error",
          confirmButtonText: "Ok",
          showCloseButton: true,
          showLoaderOnConfirm: true
        }).then(result => {
          return;
        });
      } else {
        self.placeOrderSwal(selectedData[0].unit_no);
      }
    },

    placeOrderSwal: function (unitNo) {
      var self = this;
      self.$swal({
        title: "",
        text: "Are you sure you want to Place the order?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Ok",
        cancelButtonText: "Cancel",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          self.$router.push({name: 'CustomerOrderForm', params: {unitNo}});
        } else if (result.dismiss) {
          return;
        }
      });
    },

    sellVehicle() {
      if (confirm('Are you sure that you want to sell this vehicle? ')) {
        var self = this;
        var selectedData = this.$refs['listAvailableVehicleTable'].selectedRows;
        var fields = {
          vehicle_id: selectedData[0].id
        }
        self.loading = true;
        $.ajax({
          url: process.env.ROOT_API + "/vehicle-to-sold",
          type: "POST",
          data: fields,
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
            self.loading = false;
            setTimeout(function () {
              $(".alert-success").removeClass("show");
              $(".alert-success").addClass("hide");
            }, 10000);
            alert(data.message);
            if (data.code === '200') {
              self.loadList();
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            alert(data.message);
            if (jqXHR.status === 0) {
              self.error = "Remote server cannot be reached";
            } else {
              //redirect to login page if user not authenticated
              if (jqXHR.status === 401) {
                //clear previous data
                localStorage.removeItem('user_obj');
                localStorage.removeItem('tkn');

                self.$router.push("/");
              }
              self.error = jqXHR.responseJSON.message;
            }
          }
        });
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AvailableVehiclesList.vue